import { useSimpleAgencyCouriersQuery } from 'core/graphql/Agency/SimpleAgencyCouriers.generated';

type AgencyCouriersResult = {
  couriers: Array<{
    __typename?: 'Courier';
    courierId: number;
    indicative?: string | null;
  }>;
  loadingCouriers: boolean;
  refresh: () => Promise<void>;
};

const useSimpleAgencyCouriersDataStore = (
  agencyId: string | null,
  date: string | null,
): AgencyCouriersResult => {
  const { loading, data, refetch } = useSimpleAgencyCouriersQuery({
    skip: !agencyId || !date,
    variables: agencyId && date ? { agencyId, date } : undefined,
  });

  const refresh = async () => {
    await refetch(agencyId ? { agencyId } : undefined);
  };

  if (data !== undefined) {
    return {
      couriers: data.CouriersByAgency,
      loadingCouriers: loading,
      refresh,
    };
  }

  return {
    couriers: [],
    loadingCouriers: loading,
    refresh,
  };
};

export default useSimpleAgencyCouriersDataStore;
